document.addEventListener('DOMContentLoaded', () => {
	const dynamicSelectsContainer = document.getElementById('dynamic-selects');

	if (!dynamicSelectsContainer) {
			return;
	}

	const data: { [key: string]: { provincias: { [key: string]: string[] } } } = {
			"Arequipa": {
					"provincias": {
							"Arequipa": ["Cercado", "Alto Selva Alegre", "Cayma", "Cerro Colorado", "Characato", "Chiguata", "Jacobo Hunter", "La Joya", "Mariano Melgar", "Miraflores", "Mollebaya", "Paucarpata", "Pocsi", "Polobaya", "Quequeña", "Sabandia", "Sachaca", "San Juan de Siguas", "San Juan de Tarucani", "Santa Isabel de Siguas", "Santa Rita de Siguas", "Socabaya", "Tiabaya", "Uchumayo", "Vitor", "Yanahuara", "Yarabamba", "Yura"],
							"Camana": ["Camana", "Jose Maria Quimper", "Mariscal Caceres", "Nicolas de Pierola", "Ocoña", "Quilca", "Samuel Pastor"],
							"Caraveli": ["Acarí", "Atico", "Atiquipa", "Bella Unión", "Cahuacho", "Caravelí", "Chala", "Chaparra", "Huanuhuanu", "Jaqui", "Lomas", "Quicacha", "Yauca"],
							"Castilla": ["Andagua", "Aplao", "Ayo", "Chachas", "Chilcaymarca", "Choco", "Huancarqui", "Machaguay", "Orcopampa", "Pampacolca", "Tipan", "Uñon", "Uraca", "Viraco"],
							"Caylloma": ["Achoma", "Cabanaconde", "Callalli", "Caylloma", "Chivay", "Coporaque", "Huambo", "Huanca", "Ichupampa", "Lari", "Lluta", "Maca", "Madrigal", "San Antonio de Chuca", "Sibayo", "Tapay", "Tisco", "Tuti", "Yanque"],
							"Condesuyos": ["Andaray", "Cayarani", "Chichas", "Chuquibamba", "Iray", "Rio Grande", "Salamanca", "Yanaquihua"],
							"Islay": ["Cocachacra", "Dean Valdivia", "Islay", "Mejia", "Mollendo", "Punta de Bombon"],
							"La Union": ["Alca", "Charcana", "Cotahuasi", "Huaynacotas", "Pampamarca", "Puyca", "Quechualla", "Sayla", "Tauria", "Tomepampa", "Toro"]
					}
			},
			"Huánuco": {
					"provincias": {
							"Huánuco": ["Huánuco", "Amarilis", "Chinchao", "Churubamba", "Margos", "Pillco Marca", "Quisqui", "San Francisco de Cayran", "San Pedro de Chaulan", "Santa Maria del Valle", "Yarumayo"],
							"Ambo": ["Ambo", "Cayna", "Colpas", "Conchamarca", "Huacar", "San Francisco", "San Rafael", "Tomay Kichwa"],
							"Dos de Mayo": ["La Union", "Chuquis", "Marías", "Pachas", "Quivilla", "Ripan", "Shunqui", "Sillapata", "Yanas"],
							"Huacaybamba": ["Huacaybamba", "Canchabamba", "Cochabamba", "Pinra"],
							"Huamalies": ["Llata", "Arancay", "Chavín de Pariarca", "Jacas Grande", "Jircan", "Miraflores", "Monzón", "Punchao", "Puños", "Singa", "Tantamayo"],
							"Leoncio Prado": ["Rupa Rupa", "Daniel Alomia Robles", "Hermilio Valdizan", "Jose Crespo y Castillo", "Luyando", "Mariano Damaso Beraun", "Pucayacu", "Santo Domingo de Anda"],
							"Marañon": ["Huacrachuco", "Cholon", "San Buenaventura"],
							"Pachitea": ["Panao", "Chaglla", "Molino", "Umari"],
							"Puerto Inca": ["Puerto Inca", "Codo del Pozuzo", "Honoria", "Tournavista", "Yuyapichis"],
							"Lauricocha": ["Jesus", "Baños", "Jivia", "Queropalca", "Rondos", "San Francisco de Asis", "San Miguel de Cauri"],
							"Yarowilca": ["Chavinillo", "Cahuac", "Chacabamba", "Aparicio Pomares", "Jacas Chico", "Obas", "Pampamarca"]
					}
			}
	};

	function createSelect(name: string, options: string[], placeholder: string) {
			const select = document.createElement('select');
			select.name = name;
			select.innerHTML = `<option value="">${placeholder}</option>`;
			options.forEach(option => {
					const optionElement = document.createElement('option');
					optionElement.value = option;
					optionElement.textContent = option;
					select.appendChild(optionElement);
			});
			return select;
	}

	function updateProvincias(departamento: string) {
			const provincias = data[departamento] ? Object.keys(data[departamento].provincias) : [];
			if (!dynamicSelectsContainer) return;
			const provinciaSelect = dynamicSelectsContainer.querySelector('select[name="provincia"]') as HTMLSelectElement;
			provinciaSelect.innerHTML = '<option value="">Seleccione una provincia</option>';
			provincias.forEach(provincia => {
					const optionElement = document.createElement('option');
					optionElement.value = provincia;
					optionElement.textContent = provincia;
					provinciaSelect.appendChild(optionElement);
			});
			updateDistritos(departamento, provinciaSelect.value);
	}

	function updateDistritos(departamento: string, provincia: string) {
			const distritos = data[departamento]?.provincias[provincia] || [];
			if (!dynamicSelectsContainer) return;
			const distritoSelect = dynamicSelectsContainer.querySelector('select[name="distrito"]') as HTMLSelectElement;
			distritoSelect.innerHTML = '<option value="">Seleccione un distrito</option>';
			distritos.forEach(distrito => {
					const optionElement = document.createElement('option');
					optionElement.value = distrito;
					optionElement.textContent = distrito;
					distritoSelect.appendChild(optionElement);
			});
	}

	const departamentoSelect = createSelect('departamento', Object.keys(data), 'Seleccione un departamento');
	dynamicSelectsContainer.appendChild(departamentoSelect);

	const provinciaSelect = createSelect('provincia', [], 'Seleccione una provincia');
	dynamicSelectsContainer.appendChild(provinciaSelect);

	const distritoSelect = createSelect('distrito', [], 'Seleccione un distrito');
	dynamicSelectsContainer.appendChild(distritoSelect);

	departamentoSelect.addEventListener('change', () => {
			const departamento = departamentoSelect.value;
			updateProvincias(departamento);
	});

	provinciaSelect.addEventListener('change', () => {
			const departamento = departamentoSelect.value;
			const provincia = provinciaSelect.value;
			updateDistritos(departamento, provincia);
	});
});